// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ProjectSchema = z.object({
  id: z.number().int(),
  active: z.boolean(),
  account_id: z.number().int(),
  name: z.coerce.string(),
  description: z.nullable(z.coerce.string()),
  color: z.optional(z.coerce.string().min(3).max(6).regex(new RegExp("^([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$")).describe("hex code")),
  rate_type: z.enum(["project", "user", "non-billable"]),
  billable: z.boolean(),
  created_at: z.number().int(),
  updated_at: z.number().int(),
  external_id: z.coerce.string().nullish(),
  budget_scope: z.nullable(z.enum(["tag", "project"])),
  client: z.object({
    id: z.number().int(),
    name: z.coerce.string(),
    active: z.boolean(),
    external_id: z.nullable(z.coerce.string()),
    updated_at: z.string().datetime(),
    color: z.coerce.string(),
    external_references: z.optional(z.array(z.object({
      id: z.number().int(),
      provider_type: z.coerce.string(),
      provider_id: z.coerce.string(),
      updated_at: z.string().datetime(),
      connection_id: z.number().int(),
      url: z.coerce.string().url(),
    }))),
    tic: z.optional(z.object({
      uri: z.coerce.string(),
      tool_id: z.coerce.string().nullish(),
      external_url: z.coerce.string().nullish(),
    })),
  }),
  required_notes: z.boolean(),
  required_labels: z.boolean(),
  budget_expired_on: z.nullable(z.string().datetime()),
  has_recurrence: z.boolean(),
  enable_labels: z.enum(["all", "none", "custom"]),
  created_from: z.coerce.string(),
  default_labels: z.boolean(),
  allow_only_one_tag: z.boolean().describe("Whether only one tag is allowed per time entry"),
  currency: z.object({
    id: z.coerce.string(),
    name: z.coerce.string().min(1),
    iso_code: z.coerce.string(),
    symbol: z.coerce.string(),
    symbol_first: z.boolean(),
  }),
  team_ids: z.optional(z.array(z.number().int())),
  update_hour_billable_state: z.optional(z.boolean()),
  budget: z.optional(z.number()),
  budget_type: z.optional(z.enum(["H", "M"])),
  budget_calculation: z.optional(z.enum(["pending", "completed"])),
  hour_rate: z.optional(z.number()),
  hour_rate_in_cents: z.optional(z.number()),
  budget_progress: z.optional(z.number()),
  budget_percent: z.optional(z.number()),
  invoice_by_budget: z.optional(z.boolean()),
  users: z.optional(z.array(z.object({
    user_id: z.number().int(),
    hour_rate: z.number(),
    hour_rate_in_cents: z.number(),
    updated_at: z.string().datetime(),
    created_at: z.string().datetime(),
    deleted: z.boolean(),
    internal_hour_rate: z.number(),
    internal_hour_rate_in_cents: z.number(),
  }))),
  labels: z.optional(z.array(z.object({
    project_id: z.number().int(),
    label_id: z.number().int(),
    budget: z.number(),
    required: z.boolean(),
    default: z.boolean(),
    updated_at: z.string().datetime(),
  }))),
  label_ids: z.optional(z.array(z.number().int())),
  required_label_ids: z.optional(z.array(z.number().int())),
  default_label_ids: z.optional(z.array(z.number().int())),
  first_logged_on: z.string().date().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])$")).describe("The date in ISO 8601 format (YYYY-MM-DD)").nullish(),
  last_logged_on: z.string().date().regex(new RegExp("^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])$")).describe("The date in ISO 8601 format (YYYY-MM-DD)").nullish(),
  locked_hours: z.optional(z.boolean().describe("Whether the project has locked or billed or invoiced hours")),
  tic: z.optional(z.object({
    uri: z.coerce.string().describe("Canonical TIC identifier (e.g., tic://jira/workspace-id/projects/KEY). Immutable once set."),
    tool_id: z.coerce.string().describe("Original external tool identifier (e.g., jira, trello, asana).").nullish(),
    external_url: z.coerce.string().describe("Direct link to the project in the external tool.").nullish(),
  }).describe("Integration metadata (internal only). Present for synced projects.")),
  cost: z.optional(z.union([z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }), z.object({})]).describe("V1::Cost schema or empty object")),
  estimated_cost: z.optional(z.union([z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }), z.object({})]).describe("V1::Cost schema or empty object")),
  billed_cost: z.optional(z.union([z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }), z.object({})]).describe("V1::Cost schema or empty object")),
  unbilled_cost: z.optional(z.union([z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }), z.object({})]).describe("V1::Cost schema or empty object")),
  internal_cost: z.optional(z.union([z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }), z.object({})]).describe("V1::Cost schema or empty object")),
  profit: z.optional(z.union([z.object({
    fractional: z.number().int(),
    formatted: z.coerce.string().min(1),
    amount: z.number(),
    currency_code: z.coerce.string().min(1),
  }), z.object({})]).describe("V1::Cost schema or empty object")),
  duration: z.optional(z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  })),
  estimated_duration: z.optional(z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  })),
  billed_duration: z.optional(z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  })),
  unbilled_duration: z.optional(z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  })),
  billable_duration: z.optional(z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  })),
  non_billable_duration: z.optional(z.object({
    hours: z.number().int(),
    minutes: z.number().int(),
    seconds: z.number().int(),
    formatted: z.coerce.string().min(1),
    total_hours: z.number(),
    total_seconds: z.number().int(),
    total_minutes: z.number().int(),
  })),
  profitability: z.optional(z.number()),
});
